import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

const SkeletonLoader = ({ color, highlightColor, ...props }) => {
    const layoutType = useSelector((state) => state.appReducer.layoutType);

    return layoutType === "dark" ? (
        <SkeletonTheme color={color} highlightColor={highlightColor}>
            <Skeleton {...props} />
        </SkeletonTheme>
    ) : (
        <Skeleton {...props} />
    );
};

SkeletonLoader.defaultProps = {
    color: "grey",
    highlightColor: "#F7FAFA"
};

SkeletonLoader.propTypes = {
    color: PropTypes.string,
    highlightColor: PropTypes.string
};

export default SkeletonLoader;
